import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Setting from "./pages/Setting";

import FunnelsView from "./views/FunnelsView";
import MenuAnalyticsView from "./views/MenuAnalyticsView";
import ErrorsView from "./views/ErrorsView";
import MnoConfigsView from "./views/MnoConfigsView";
import SimulatorView from "./views/SimulatorView";

import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import { TelemetryProvider } from "./context/TelemetryContext";

function App() {
  // SSO Token Handover receiver
  React.useEffect(() => {
    const hash = window.location.hash || "";
    const search = window.location.search || "";
    let token = null;

    if (hash.includes("access_token=")) {
      const match = hash.match(/access_token=([^&]+)/);
      if (match && match[1]) {
        token = decodeURIComponent(match[1]);
      }
    } else if (search.includes("access_token=")) {
      const match = search.match(/[?&]access_token=([^&]+)/);
      if (match && match[1]) {
        token = decodeURIComponent(match[1]);
      }
    }

    if (token) {
      localStorage.setItem("accessToken", token);
      localStorage.setItem("isAuthenticated", "true");
      // Clean URL hash without reload
      window.history.replaceState(null, "", window.location.pathname);
    }
  }, []);

  return (
    <TelemetryProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Login Route */}
          <Route path="/login" element={<Login />} />

          {/* Protected Application Routes */}
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            {/* Dashboard / Overview */}
            <Route path="/dashboard" element={<Dashboard />} />

            {/* USSD Funnel Telemetry */}
            <Route path="/funnels" element={<FunnelsView />} />

            {/* Menu Drilldown & Latency */}
            <Route path="/menus" element={<MenuAnalyticsView />} />

            {/* Errors & Drop-off Friction */}
            <Route path="/errors" element={<ErrorsView />} />

            {/* MNO Gateway Configuration */}
            <Route path="/configs" element={<MnoConfigsView />} />

            {/* Interactive USSD Sandbox */}
            <Route path="/simulator" element={<SimulatorView />} />

            {/* Engine Settings */}
            <Route path="/setting" element={<Setting />} />
          </Route>

          {/* Fallback Redirect */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </TelemetryProvider>
  );
}

export default App;